import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { ScopeChangeRequestActionSelectionDialog } from '@/features/admin/scope-change-requests/ScopeChangeRequestActionSelectionDialog'
import { type ScopeChangeRequestActionSelectionDialogViewModel } from './ScopeChangeRequestActionSelectionDialogViewModel'

export interface ScopeChangeRequestActionSelectionDialogContainerProps {
  vm: ScopeChangeRequestActionSelectionDialogViewModel
}

export const ScopeChangeRequestActionSelectionDialogContainer = observer(
  function ScopeChangeRequestActionSelectionDialogContainer({
    vm,
  }: ScopeChangeRequestActionSelectionDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <ScopeChangeRequestActionSelectionDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        corporateMode={shellInfo.corporateMode}
        actionType={vm.actionType}
        onActionChange={vm.setAction}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
      />
    )
  },
)
